import AppliedFilters from '@bd/bdui-appliedfilters';
import styled from '@bd/bdui-styles/emotion';
import { colors } from '../styles';

export default styled(AppliedFilters)`
  position: relative;
  margin: 10px 0 0 0;
  @media (min-width: 992px) {
    margin: 0;
  }
  .AppliedFilters_list {
    margin: 0;
    padding: 20px 10px 40px 10px;
    list-style: none;
    width: 100%;
    background-color: ${colors.color3Lightest};
    @media (min-width: 992px) {
      padding: 10px 30px;
    }
  }
  .AppliedFilters_listItem {
    display: inline-block;
    margin: 0 10px 5px 0;
  }
  .AppliedFilters_listItemButton {
    padding: 6px 26px 6px 6px;
    font-weight: 800;
    font-size: 13px;
    background-image: url('/images/icon-close-circle-gold.svg');
    background-position: calc(100% - 6px) center;
    background-repeat: no-repeat;
    background-color: ${colors.color3Dark};
    border-radius: 3px;
    cursor: pointer;
  }
`;



// WEBPACK FOOTER //
// ./src/components/AppliedFilters.js